<template>
    <div class="">

        <div class="smalltitle" style="margin-left: -5px;">Financial Information</div>

        <div class="blockcont" style="margin-bottom: 15px;">
            <div class="profield panel-heading bmt-15" style="width: 100%;" role="tab" id="headingOne">
                <div class="row">
                    <div class="col-xs-7" style="margin-top: 15px;">
                        <strong>Credit and Debit Card</strong>
                    </div>
                    <div class="col-xs-3" style="margin-top: 15px;">
                        <strong>Expiration</strong>
                    </div>
                </div>
            </div>
            <div class="blockcont">
                <ul class="itemlist">
                    <li v-for="paymentSetting in payments" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="row" style="line-height: 38px;">
                            <a href="javascript:void(0);" @click.prevent="clickShowDetail(paymentSetting)">
                                    <span class="col-xs-7">
                                        <img v-if="Number(paymentSetting.type) == 0" style="width: 40px;"
                                             :src="getLinkWiki('images/visa.png')"/>
                                        <img v-if="Number(paymentSetting.type) == 1" style="width: 40px;"
                                             :src="getLinkWiki('images/master_card.png')"/>
                                        <img v-if="Number(paymentSetting.type) == 2" style="width: 40px;"
                                             :src="getLinkWiki('images/amex.png')"/>
                                        <img v-if="Number(paymentSetting.type) == 3" style="width: 40px;"
                                             :src="getLinkWiki('images/discover.png')"/>
                                        ending in <span
                                            class="number_account">{{getNumber(paymentSetting.number)}}</span></span>
                                <span class="col-xs-3" style="">{{getExpirationDate(paymentSetting)}}</span>
                            </a>
                        </div>
                        <div class="clearfix"></div>
                        <div class="blockcont" v-if="paymentSetting.showBlockDetail">
                            <form>
                                <div class="prolabel">Card holder</div>
                                <div class="profield">
                                    <input type="text" v-model="paymentSetting.name"
                                           :disabled="disabledForm"
                                           maxlength="100">
                                </div>
                                <div class="prolabel">Card type</div>
                                <div class="profield">
                                    <select v-model="paymentSetting.type" :disabled="disabledForm">
                                        <option value="0">Visa</option>
                                        <option value="1">Master Card</option>
                                        <option value="2">Amex</option>
                                        <option value="3">Discover</option>
                                    </select>
                                </div>
                                <div class="prolabel">Card type</div>
                                <div class="profield">
                                    <select v-model="paymentSetting.type" :disabled="disabledForm">
                                        <option value="0">Visa</option>
                                        <option value="1">Master Card</option>
                                        <option value="2">Amex</option>
                                        <option value="3">Discover</option>
                                    </select>
                                </div>
                                <div class="prolabel">Card number</div>
                                <div class="profield">
                                    <input name="number_account_payment_edit"
                                           type="text" :value="getNumberEdit(paymentSetting.number)"
                                           :disabled="disabledForm">
                                </div>
                                <div class="prolabel">Expiration date</div>
                                <div class="profield">
                                    <input name="expiration_date" type="text"
                                           :value="paymentSetting.month + '/' + paymentSetting.year"
                                           :disabled="disabledForm">
                                </div>
                                <div class="prolabel">Security code</div>
                                <div class="profield">
                                    <input class="edit_security_account" type="text" v-model="paymentSetting.security"
                                           maxlength="3" :disabled="disabledForm">
                                </div>
                                <div class="prolabel">Billing Address</div>
                                <div class="profield">
                                    <ul class="itemlist">
                                        <li style="padding-bottom: 8px; line-height: 15px;"
                                            v-if="addressBillForPayment[paymentSetting.id]">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <!--<input type="radio"-->
                                                    <!--v-model="addressBillForPayment[paymentSetting.id].address_billing_id"-->
                                                    <!--selected-->
                                                    <!--:name="'address-billing-' + paymentSetting.id"-->
                                                    <!--:disabled="disabledForm"-->
                                                    <!--:value="addressBillForPayment[paymentSetting.id].id">-->
                                                    <strong class="">{{addressBillForPayment[paymentSetting.id].fullName}}</strong>
                                                    <br>
                                                    <div class="address">
                                                        {{ addressBillForPayment[paymentSetting.id].streetName
                                                        }}, {{ addressBillForPayment[paymentSetting.id].city
                                                        }},{{ addressBillForPayment[paymentSetting.id].state
                                                        }} {{addressBillForPayment[paymentSetting.id].zipCode}}, {{getCountry(addressBillForPayment[paymentSetting.id].country)}}
                                                    </div>
                                                    <div class="phone">
                                                        Phone: {{addressBillForPayment[paymentSetting.id].phone}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="clear: both"></div>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="blockcont" style="margin-bottom: 15px; ">
                <div class="profield " style="width: 100%;" role="tab" id="headingTwo">
                    <strong>Checking Account</strong>
                </div>
                <div>
                    <ul class="itemlist">
                        <li v-for="checkingAccount in checkingAccounts" style="margin-bottom: -25px;">
                            <div class="row">
                                <div class="col-xs-6" style="cursor: pointer;"
                                     @click.prevent="clickShowDetail(checkingAccount)">
                                    <div class=""><span
                                            style="text-transform: uppercase;">{{checkingAccount.bank}}</span> | <span
                                            class="account_number"> Account ending in {{checkingAccount.accountNumber}}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                            <div class="blockcont">
                                <form v-if="checkingAccount.showBlockDetail">
                                    <div class="prolabel">Bank</div>
                                    <div class="profield"><input style="text-transform: uppercase;" type="text"
                                                                 v-model="checkingAccount.bank" :disabled="disabledForm"
                                                                 maxlength="150"></div>
                                    <div class="prolabel">Routing number</div>
                                    <div class="profield"><input type="text" v-model="checkingAccount.routingNumber"
                                                                 :disabled="disabledForm" maxlength="50"></div>
                                    <div class="prolabel">Account number</div>
                                    <div class="profield"><input type="text" v-model="checkingAccount.accountNumber"
                                                                 :disabled="disabledForm" maxlength="50"></div>
                                    <div class="prolabel">Billing Address</div>
                                    <div class="profield">
                                        <ul class="itemlist">
                                            <li style="padding-bottom: 8px; line-height: 15px;"
                                                v-if="addressBillForCheckingAccount[checkingAccount.userId]">
                                                <div class="row">
                                                    <div class="col-xs-12">
                                                        <strong class="">{{addressBillForCheckingAccount[checkingAccount.userId].fullName}}</strong>
                                                        <br>
                                                        <div class="address">
                                                            {{ addressBillForCheckingAccount[checkingAccount.userId].streetName
                                                            }}, {{ addressBillForCheckingAccount[checkingAccount.userId].city
                                                            }},{{ addressBillForCheckingAccount[checkingAccount.userId].state
                                                            }} {{addressBillForCheckingAccount[checkingAccount.userId].zipCode}}, {{getCountry(addressBillForCheckingAccount[checkingAccount.userId].country)}}
                                                        </div>
                                                        <div class="phone">
                                                            Phone: {{addressBillForCheckingAccount[checkingAccount.userId].phone}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="clear: both"></div>
                                            </li>
                                        </ul>
                                    </div>

                                </form>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>

            <div class="blockcont" style="margin-bottom: 15px; ">
                <div class="profield p" style="width: 100%;">

                    <strong>Billing Address</strong>
                </div>
                <div>
                    <ul class="itemlist">
                        <li v-for="addressBilling in addressBillings" style="margin-bottom: -25px;">
                            <div class="row">
                                <div class="col-xs-9" style="cursor: pointer; line-height: 20px;"
                                     @click.prevent="clickShowDetail(addressBilling)">
                                    <div class="">{{addressBilling.fullName}}</div>
                                    <div class="address">
                                        {{ addressBilling.streetName }}, {{ addressBilling.city
                                        }}, {{ addressBilling.state
                                        }} {{addressBilling.zipCode}}, {{getCountry(addressBilling.country)}}
                                    </div>
                                    <div class="phone">Phone: {{addressBilling.phone}}</div>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                            <div class="blockcont">
                                <form v-if="addressBilling.showBlockDetail">
                                    <div class="prolabel">Country/Region</div>
                                    <div class="profield">
                                        <select v-model="addressBilling.country" :disabled="disabledForm">
                                            <option :value="s.code" v-for="s in COUNTRY_DATA">{{s.name}}</option>
                                        </select>
                                    </div>
                                    <div class="prolabel">Full Name</div>
                                    <div class="profield"><input type="text" v-model="addressBilling.fullName"
                                                                 :disabled="disabledForm">
                                    </div>
                                    <div class="prolabel">Phone number</div>
                                    <div class="profield"><input name="phone" type="text"
                                                                 v-model="addressBilling.phone"
                                                                 :disabled="disabledForm"></div>
                                    <div class="prolabel">Address</div>
                                    <div class="profield">
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <input type="text" placeholder="Address"
                                                       v-model="addressBilling.streetName" :disabled="disabledForm"
                                                       maxlength="255">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-4">
                                                <input title="Type your city" placeholder="City" type="text"
                                                       :disabled="disabledForm"
                                                       v-model="addressBilling.city" maxlength="100"/>
                                            </div>
                                            <div class="col-xs-4">
                                                <select v-model="addressBilling.state" :disabled="disabledForm">
                                                    <option :value="s.code" v-for="s in STATE">{{s.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-xs-4"><input type="text" placeholder="Zip Code"
                                                                         v-model="addressBilling.zipCode"
                                                                         :disabled="disabledForm"
                                                                         maxlength="10"></div>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin.vue'
import config from '../../../config'

let wikiUrl = config.wikiUrl
export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    payments: {},
    addressBillings: {},
    disabledForm: {},
    checkingAccounts: {}
  },
  mixins: [DetailRegularUserMixin],
  data () {
    return {
      COUNTRY_DATA: config.COUNTRY,
      STATE: config.STATE
    }
  },
  computed: {
    addressBillForPayment () {
      let data = []
      if (this.payments.length && this.addressBillings.length) {
        this.payments.map(item => {
          if (item.address_billing_id) {
            this.addressBillings.some(address => {
              if (Number(address.id) === Number(item.address_billing_id)) {
                data[item.id] = address
                return true
              }
            })
          }
        })
      }
      return data
    },
    addressBillForCheckingAccount () {
      let data = []
      if (this.checkingAccounts.length && this.addressBillings.length) {
        this.checkingAccounts.map(item => {
          if (item.address_billing_id) {
            this.addressBillings.some(address => {
              if (Number(address.id) === Number(item.address_billing_id)) {
                data[item.userId] = address
                return true
              }
            })
          }
        })
      }
      return data
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    clickShowDetail (paymentSetting) {
      if (paymentSetting.showBlockDetail) {
        paymentSetting.showBlockDetail = false
      } else {
        paymentSetting.showBlockDetail = true
      }
      this.$forceUpdate()
    },
    getNumberEdit (number) {
      return number.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, 'xxxx xxxx xxxx $4')
    },
    getNumber (number) {
      if (number) {
        return number.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$4')
      }
      return ''
    },
    getExpirationDate (payment) {
      let string = ''
      if (payment.month) {
        string += payment.month
      }

      if (payment.year) {
        string += '/' + payment.year
      }
      return string
    },
    getLinkWiki (link) {
      return wikiUrl + '/' + link
    },
    getCountry (code) {
      for (var i = 0; i < this.COUNTRY_DATA.length; i++) {
        if (this.COUNTRY_DATA[i].code === code) {
          return this.COUNTRY_DATA[i].name
        }
      }
      return code
    }
  }
}
</script>
<style scoped="">

</style>
